import { Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { ProgressBarSuspenseFallback } from '@vivaldis/web-ui'

const EditUser = lazy(() => import('./EditUser'))
const EditUserEmailPreferences = lazy(
  () => import('./EditUserEmailPreferences')
)
const UserList = lazy(() => import('./UserList'))
const ViewUser = lazy(() => import('./ViewUser'))

export const UsersRoutes = () => {
  return (
    <Suspense fallback={ProgressBarSuspenseFallback}>
      <Routes>
        <Route path="/" element={<UserList />} />
        <Route path="/:userId/edit-user" element={<EditUser />} />
        <Route
          path="/:userId/edit-user-email-preferences"
          element={<EditUserEmailPreferences />}
        />
        <Route path="/:userId/view-user" element={<ViewUser />} />
      </Routes>
    </Suspense>
  )
}
